export enum SetClaimTypeInterface {
    AppRole = 0,
    AppUser = 1

}

export enum UseStatus {
    All = -1,
    Disabled = 0,
    Active = 1,

}

export enum WaterInvoiceStatus {
    All = "All",
    Unpaid = "Unpaid",
    Paid = "Paid",
    Canceled = "Canceled",

}

export enum WaterInvoiceApproveStatus {
    All= "All",
    NotApprove= "NotApprove",
    Approved= "Approved",

}

export enum ExportEInvoiceStatus {
    All,
    UnSend,
    UnSign,
    Signed,
    SyncTax,
    Replace,
    Adjust,
    Canceled,
    Approved,
}

export enum UseWaterRegisterStatus {
    All="All",
    New="New",
    InProcess="InProcess",
    Completed="Completed",
    Rejected="Rejected",
}

export enum WaterIndexStatus
{
    PENDING="PENDING",
    COMPLETED="COMPLETED",
    CONFIRMED="CONFIRMED",
    CANCELLED="CANCELLED",
}

export function getUseWaterRegisterStatusDisplay(value: string) {
    switch(value) {
        case UseWaterRegisterStatus.All: return "Tất cả";
        case UseWaterRegisterStatus.New: return "Mới";
        case UseWaterRegisterStatus.InProcess: return "Đang xử lý";
        case UseWaterRegisterStatus.Completed: return "Hoàn thành";
        case UseWaterRegisterStatus.Rejected: return "Từ chối";
        default: return "";
    }
}

export enum UnitTypeRegister {
    All="All",
    Individual="Individual",
    Organization="Organization",
}

export function getUnitTypeRegisterDisplay(value: string) {
    switch(value) {
        case UnitTypeRegister.All: return "Tất cả";
        case UnitTypeRegister.Individual: return "Cá nhân";
        case UnitTypeRegister.Organization: return "Tổ chức";
        default: return '';
    }
}


export enum WaterUserStatus {
    All="All",
    Processing="Processing",
    Active="Active",
    TempDisabled="TempDisabled",
    Disabled="Disabled",

}

export enum NotificationMethodType {
    All = "All",
    Zalo = "Zalo",
    Sms = "Sms",
    App = "App",
}

export enum PaymentMethodType {
    All= "All",
    Bank= "Bank",
    Transfer= "Transfer",
    EWallet= "EWallet",
    Manual= "Manual",
    HomePay= "HomePay",
    CentralPaid= "CentralPaid",
    Debtminusdeposit= "Debtminusdeposit",
    CollectVNPayQr= "CollectVNPayQr"
}

export enum ComponentMode {
    Page,
    Component
}

export enum SendMailStatus {
    Unsend,
    Send,
    Error
}

export enum MenuType {
    All,
    Top,
    Bottom,
    Side
}

export enum LineType {
    All,
    Raw,
    Transmission,
    Distribution,
    Service
}

export enum PointType {
    All,
    Root,
    Factory,
    Collection,
    Leaf
}

export enum TopUpType {
    All,
    Personal,
}

export enum UserRequestStatus {
    All = "All",
    Pending = "Pending",
    InProcess = "InProcess",
    Completed = "Completed",
    Cancelled = "Cancelled",
}

export enum UserRequestType {
    All = "All",
    Leak = "Leak",
    WaterLoss = "WaterLoss",
    WaterQuality = "WaterQuality",
    Payment = "Payment",
    Meter = "Meter",
    Other = "Other",
}

export enum FeeLadderType {
    All = "All",
    IncludeEnviromentFee = "IncludeEnviromentFee",
    NotIncludeTaxFee = "NotIncludeTaxFee",
}

export enum AccountingSoftwareType {
    All = 0,
    Fast = 1,
    EasyBook = 2,

}

export enum WaterUserDepositStatus {
    All = "All",
    No = "No",
    HalfPaid = "HalfPaid",
    FullPaid = "FullPaid",

}


export enum CreateInvoiceSetting {
    None = 0,
    Auto = 1
}

export enum InvoiceDateType {
    All = "All",
    InMonth = "InMonth",
    ByReadDate = "ByReadDate",

}

export enum TransactionExtraType {
    WaterInvoiceMinusDeposit = "WaterInvoiceMinusDeposit",
    Deposit = "Deposit",
    Refund = "Refund",
    Payment = "Payment",
    EnvironmentFee = "EnvironmentFee",
    EmployeeDepositDebit = "EmployeeDepositDebit",
    EmployeeWaterInvoice = "EmployeeWaterInvoice",
    EmployeeDebt = "EmployeeDebt"
}

export enum SuspensionStatus {
    Disabled = "Disabled",
    Active = "Active"
}

export enum AuditLogTableTitle {
    AppUser = "AppUser",
    AppRole = "AppRole",
    WaterUser = "WaterUser",
    WaterInvoice = "WaterInvoice",
    WaterInvoiceRow = "WaterInvoiceRow",
    Transaction = "Transaction",
    WaterIndex = "WaterIndex",
    UnitType = "UnitType",
    TollArea = "TollArea",
    WaterMeter = "WaterMeter",
}

export enum PaymentWithAccountantMethod {
    Transfer = "Transfer",
    Debtminusdeposit = "Debtminusdeposit",
    Manual = "Manual",
}

export enum AppUserAreaType {
    Province = "Province",
    District = "District",
    Ward = "Ward",
    TollArea = "TollArea",
}

export enum TransactionObjectType {
    AppUser = "AppUser",
    WaterUser = "WaterUser",
}

export enum BillingPaymentType {
    Transfer = "Transfer",
    Cash = "Cash",
    Debtminusdeposit = "Debtminusdeposit",
    CollectVNPayQr = "CollectVNPayQr",
    CollectEmployee = "CollectEmployee",
}